export const en = {
    'adaptive-banner': 'Adaptive ad',
    additions: 'Extensions: {additionsList}',
    'banner-id': '№ {id}',
    duration: '{duration} sec'
};
